<template>
    <Modal @modal:dismiss="$emit('dismiss')" class="blue-theme">
        <div slot="header">
            <div class="text-center">
                <font-awesome-layers class="fa-5x">
                    <font-awesome-icon icon="circle" class="blue-theme" />
                    <font-awesome-icon
                        icon="window-close"
                        class="fa-inverse"
                        transform="shrink-6"
                    />
                </font-awesome-layers>
            </div>
            <h3><slot name="header" /></h3>
        </div>

        <div slot="body">
            <div class="form-control text-center"><slot name="body" /></div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch blue-theme" @click="$emit('dismiss')">
                    Annuler
                </CustomButton>
                <CustomButton class="stretch default blue-theme" @click="$emit('close')">
                    Clore
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomButton from './../Button';

export default {
    props: ['value'],
    data() {
        return {};
    },
    components: {
        Modal,
        CustomButton,
    },
};
</script>

<style lang="scss">
.text-center {
    text-align: center;
    margin-bottom: 22px;
}

svg.blue-theme {
    color: #6cd3fb;
}
</style>
